import React from 'react'
import { NavLink } from "react-router-dom"
import { motion } from "motion/react"

const Work = ({ imgsrc, title, text, view, source, date, hideBtns }) => {
  const hasLinks = view || source || hideBtns;

  return (
    <motion.div
      whileHover={{ y: -4 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
      className="flex h-full flex-col overflow-hidden rounded-lg border border-ink-800 bg-ink-900"
    >
      <img className="h-48 w-full object-cover" src={imgsrc} alt={title} />

      <div className="flex flex-1 flex-col p-5">
        <h2 className="mb-2 text-lg font-semibold text-mist-100">{title}</h2>
        <p className="mb-4 flex-1 text-sm leading-relaxed text-mist-500">{text}</p>

        {hasLinks ? (
          <div className="mt-auto flex items-center justify-between pt-2 font-mono text-xs">
            {view ? (
              <NavLink to={view} className="hover-underline text-signal-400">Learn More</NavLink>
            ) : <span />}
            {source ? (
              <a href={source} target="_blank" rel="noreferrer" className="hover-underline text-mist-500">Source</a>
            ) : <span />}
          </div>
        ) : (
          <div className="mt-auto pt-2 text-center font-mono text-xs text-mist-500">Page Coming Soon</div>
        )}

        <div className="mt-3 border-t border-ink-800 pt-3">
          <small className="font-mono text-xs text-mist-500">{date}</small>
        </div>
      </div>
    </motion.div>
  )
}

export default Work
